import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './VisionMission.css';

// Import your icons from assets
import VisionIcon from '../../Assets/VisionMission/solar_target-outline.webp'; 
import MissionIcon from '../../Assets/VisionMission/simple-line-icons_rocket.webp';
import ComplianceIcon from '../../Assets/VisionMission/material-symbols-light_verified-outline.webp';

const VisionMission = () => {
  const cardData = [
    {
      id: 1,
      icon: VisionIcon,
      title: "Our Vision",
      text: "To Be A Trusted Automobile Logistics Partner Delivering Reliable And Compliant Transport Solutions Across India."
    },
    {
      id: 2,
      icon: MissionIcon,
      title: "Our Mission",
      text: "To deliver safe, efficient, and cost-effective logistics through operational excellence and customer focus."
    },
    {
      id: 3,
      icon: ComplianceIcon,
      title: "Safety & Compliance",
      text: "All operations strictly comply with CMVR standards, supported by trained drivers and disciplined processes."
    }
  ];

  return (
    <section className="vision-mission-section">
      <div className="container-fluid px-lg-5 mb-5">
        <div className="row">
          
          {/* Left Side: Sticky Text Content */}
          <div className="col-lg-5 mb-5 mb-lg-0">
            <div className="sticky-content">
              <span className="text-uppercase small fw-semibold letter-spacing-2 text-white">
                Vision, Mission & Compliance
              </span>
              <h2 className="display-4  text-white mt-3 mb-4" style={{fontSize:"50px" , fontWeight:500}}>
                Guided By Purpose.<br />
                Driven By Responsibility.
              </h2>
              <p className="text-white  lh-base" style={{ maxWidth: '650px', fontSize:"20px" }}>
                Our Vision And Mission Define How We Operate, Grow, And Serve 
                Our Customers. Every Movement Is Guided By Safety, 
                Compliance, And A Commitment To Long-Term Value Creation.
              </p>
            </div>
          </div>

          {/* Right Side: Stacking Cards */}
          <div className="col-lg-7">
            <div className="card-stack">
              {cardData.map((card, index) => (
                <div 
                  className="stack-card" 
                  key={card.id} 
                  style={{ 
                    top: "140px", // Staggered offset
                    zIndex: index + 1 
                  }}
                >
                  <div className="card-inner shadow-lg">
                    <div className="icon-box mb-4">
                       <img src={card.icon} alt={card.title} style={{width: '35px', height: '35px'}} />
                    </div>
                    <h3 className="fw-bold mb-3 text-dark">{card.title}</h3>
                    <p style={{textAlign:"start"}} className="text-secondary fs-5">{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VisionMission;